import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
export const VideoInfoRow = (props) => {
    if (!props.value) {
        return null;
    }
    return (React.createElement("div", { className: css(styles.row) },
        React.createElement("div", { className: css(styles.name) },
            props.name,
            "\uFF1A"),
        React.createElement("div", { className: css(styles.value) }, props.value)));
};
const styles = StyleSheet.create({
    row: {
        display: 'flex',
        flexDirection: 'row',
    },
    name: {
        fontSize: 11,
        fontWeight: 300,
        lineHeight: '1.5',
        color: Colors.GrayDarkest,
        [MediaBreakPointUp.SM]: {
            fontSize: 12,
        },
    },
    value: {
        fontSize: 11,
        fontWeight: 300,
        lineHeight: '1.5',
        color: Colors.GrayDarkest,
        [MediaBreakPointUp.SM]: {
            fontSize: 12,
        },
    },
});
